import { Card, CardBody, CardTitle, CardSubtitle, Row } from "reactstrap";
import { PacmanLoader } from "react-spinners";
import StudentSchool from "../../components/Student/StudentSchool";
import { GetStudentProfile } from "../../actions/studentQueries";

export default function StudentProfile() {
  const profile = GetStudentProfile();

  if (profile.isPending) {
    return (
      <div
        className="sweet-loading"
        style={{ position: "fixed", top: "50%", left: "50%" }}
      >
        <PacmanLoader color={"#20a8d8"} loading={true} />
      </div>
    );
  }

  let schoolList;

  if (profile.data?.classes?.length) {
    schoolList = profile.data.classes.map((schoolclass) => (
      <StudentSchool school={schoolclass} key={schoolclass.schoolId} />
    ));
  }

  return (
    <div className="animated fadeIn">
      <Card>
        <CardBody>
          <CardTitle>{profile.data?.name}</CardTitle>
          <CardSubtitle>
            <i className="fa fa-envelope" />
            &nbsp;&nbsp;
            {profile.data?.email}
          </CardSubtitle>

          <Row style={{ marginTop: "10px" }}>{schoolList}</Row>
        </CardBody>
      </Card>
    </div>
  );
}
